import React from 'react';
import { useField } from 'react-final-form';
import { type ConditionalFieldValueInputProps } from './ConditionalFieldValueFactory';
import { StyledInput } from './styled';

export function ConditionalNumberField({
  name,
  ...inputFieldProps
}: ConditionalFieldValueInputProps['inputFieldProps']) {
  const {
    input: { value: fieldValue, onChange: onFieldValueChange },
  } = useField(name);

  return (
    <StyledInput
      name={name}
      onChange={onFieldValueChange}
      value={fieldValue}
      type="number"
      dontSaveSpaceForErrorText
      {...inputFieldProps}
    />
  );
}
